'use client'

import Link from 'next/link'
import {useState} from 'react'
import s from './style.module.scss'
import {usePathname, useSearchParams} from 'next/navigation'
import clsx from 'clsx'
import Spinner from '@app/icons/spinner'
import {supportedLanguages} from '@app/i18n/settings'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {sessionStartQPKey} from '@app/analytics/helper'

function BackToHomeLink() {
  const path = usePathname()
  const searchParams = useSearchParams()
  const updatedQuery = {...Object.fromEntries(searchParams?.entries() ?? []), [sessionStartQPKey]: '404'}
  const [isLoading, setIsLoading] = useState(false)
  const lang = supportedLanguages.find((lang) => path?.includes(lang)) || 'en'

  return (
    <Link
      prefetch={false}
      href={{
        pathname: `/${lang}`,
        query: {...updatedQuery},
      }}
      onClick={() => {
        triggerAnalytics('back-to-home-clicked').sendAll()
        setIsLoading(true)
      }}
      className={clsx(s.link, {[s.loading]: isLoading})}
    >
      {isLoading ? <Spinner className='size-20 mx-auto' /> : 'CONTINUE TO HOMEPAGE'}
    </Link>
  )
}

export default BackToHomeLink
